import { Tool } from '@services/tools';
import { CallCard } from '@models/imported/SagaSchema/CallCard';

export class AddStampTool extends Tool {
  constructor(name: string, executor: (callcard: CallCard) => void) {
    super(name, '', '', 0, context => executor(context[0]));
  }
}
